import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ReactTable from "react-table";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBatteryThreeQuarters,
  faChargingStation,
  faLocationArrow,
  faLock,
  faLockOpen,
  faSignal
} from "@fortawesome/free-solid-svg-icons";
import getProgressBar from "views/pages/bikes/helpers/get-progress-bar";
import filterCaseInsensitive from "helpers/react-table-case-insensitive";
import {
  getAlertTypes,
  getAlerts
} from "actions/bike/actions";
import {
  testAlert
} from "actions/test/actions";

class Alerts extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 0,
      size: 30,
      sort: "id,asc"
    };

    this.getColumns = this.getColumns.bind(this);

    this.props.getAlertTypes();
    this.props.getAlerts();
  }

  // endDate: 0
  // purchaseItemId: null
  // purchaseItemType: null
  getColumns = () => [
    {
      id: "ID",
      Header: "#",
      accessor: "id",
      Cell: ({ original }) => (
        <Link to={`/bikes/${original.bike ? original.bike.id : ""}`}>
          {original.bike ? original.bike.id : ""}
        </Link>
      )
    },
    {
      id: "level",
      Header: "Level",
      accessor: "level",
      Cell: ({ original }) => {
        let level = "Information",
          className = "text-info";
        if (original.level === "WARN") {
          level = "Warning";
          className = "text-warning";
        } else if (original.level === "CRITICAL") {
          level = "Critical";
          className = "text-danger";
        }
        return (
          <b className={className}>
            {level}
          </b>
        );
      }
    },
    {
      id: "qr",
      Header: "QR",
      accessor: original => (original.bike && original.bike.qr
        ? original.bike.qr
        : ""),
    },
    {
      id: "tags",
      Header: "Tags",
      Cell: ({ original }) => (original.bike && original.bike.tags
        ? original.bike.tags.map(item => <span className="badge badge-warning" key={item}>{item}</span>)
        : ""),
      style: {
        whiteSpace: "unset"
      }
    },
    {
      id: "speed",
      Header: "Speed",
      accessor: original => (
        <div
          className={original.bike && original.bike.condition && original.bike.condition.speed ? "text-success" : "text-muted"}>
          {`${original.bike && original.bike.condition ? original.bike.condition.speed : 0} km/h`}
        </div>
      ),
    },
    {
      id: "lastRideUser",
      Header: "Last Rider",
      accessor: "lastRideUser",
      Cell: ({ original }) => {
        if (original.bike && original.bike.lastRideUser) {
          return (
            <Link to={`/users/${original.bike.lastRideUser}`}>
              {original.bike.lastRideUser}
            </Link>
          );
        }
        return null;
      }
    },
    {
      id: "lastBookUser",
      Header: "Last Booked",
      accessor: "lastBookUser",
      Cell: ({ original }) => {
        if (original.bike && original.bike.lastBookUser) {
          return (
            <Link to={`/users/${original.bike.lastBookUser}`}>
              {original.bike.lastBookUser}
            </Link>
          );
        }
        return null;
      }
    },
    {
      id: "voltage",
      Header: "Voltage",
      className: "text-center",
      headerClassName: "text-center",
      accessor: original => (original.bike && original.bike.condition
        ? original.bike.condition.voltage
        : ""),
      Cell: ({ original }) => (
        <div>
          {original.bike && original.bike.condition
            ? getProgressBar(original.bike.condition)
            : null}
        </div>
      )
    },
    {
      id: "charging",
      Header: "Charging",
      className: "text-center",
      headerClassName: "text-center",
      accessor: original => (original.bike && original.bike.condition ? original.bike.condition.charging : ""),
      Cell: ({ original }) => (
        <div>
          {original.bike && original.bike.condition ?
            <FontAwesomeIcon
              icon={original.bike.condition.charging
                ? faChargingStation
                : faBatteryThreeQuarters}
              className={original.bike.condition.charging ? "text-danger" : "text-success"}
            />
            : null}
        </div>
      )
    },
    {
      id: "gps",
      Header: "GPS",
      className: "text-center",
      headerClassName: "text-center",
      accessor: original => (original.bike && original.bike.condition ? original.bike.condition.gps : ""),
      Cell: ({ original }) => (
        <div>
          {original.bike && original.bike.condition ?
            <FontAwesomeIcon
              icon={faLocationArrow}
              className={original.bike.condition.gps ? "text-success" : "text-danger"}
            />
            : null}
        </div>
      ),
    },
    {
      id: "online",
      Header: "Online",
      className: "text-center",
      headerClassName: "text-center",
      accessor: original => (original.bike && original.bike.condition ? original.bike.connected.online : ""),
      Cell: ({ original }) => (
        <div>
          {original.bike && original.bike.condition ?
            <FontAwesomeIcon
              icon={faSignal}
              className={original.bike.connected.online ? "text-success" : "text-danger"}
            />
            : null}
        </div>
      )
    },
    {
      id: "sim",
      Header: "Sim",
      accessor: original => (original.bike && original.bike ? original.bike.sim : ""),
      Cell: ({ original }) => (
        <div>
          {original.bike ?
            <div>{original.bike && original.bike.sim && original.bike.sim.phone ? original.bike.sim.phone : "No Phone"}</div>
            : null}
          {original.bike ?
            <small
              className="text-muted">{original.bike.sim && original.bike.sim.serial ? original.bike.sim.serial : "No Serial"}</small>
            : null}
        </div>
      ),
    },
    {
      id: "locked",
      Header: "Locked",
      className: "text-center",
      headerClassName: "text-center",
      accessor: original => (original.bike && original.bike.condition ? original.bike.condition.closed : ""),
      Cell: ({ original }) => (
        <div>
          {original.bike && original.bike.condition ?
            <FontAwesomeIcon
              icon={original.bike.condition.closed
                ? faLock
                : faLockOpen}
              className={original.bike.condition.closed ? "text-success" : "text-danger"}
            />
            : null}
        </div>
      )
    },
  ];

  render() {
    const {
      loading,
      alerts,
      // alertTypes,
    } = this.props;

    return (
      <div className="w-100 p-2">
        <h1 className="h-3">Alerts History</h1>
        <ReactTable
          data={alerts || []}
          headerClassName="table-header"
          columns={this.getColumns()}
          pageSizeOptions={[10, 20, 50, 100]}
          resizable
          className="-striped -highlight table-header-padding"
          loading={loading}
          filterable={false}
          defaultFilterMethod={filterCaseInsensitive}
          style={{
            height: "calc(100vh - 140px)"
          }}
          manual={false}
          pageSize={Math.max(20, 20)}
        />

        {/*
                <button
                    className="btn btn-danger mt-2"
                    onClick={() => this.props.testAlert(355951091705009)}
                >
                    Test Alert
                </button>
                */}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.bike.loading,
  alerts: state.bike.alerts,
  alertTypes: state.bike.alertTypes,
});

const mapStateToDispatch = dispatch => ({
  getAlertTypes: bindActionCreators(getAlertTypes, dispatch),
  getAlerts: bindActionCreators(getAlerts, dispatch),

  testAlert: bindActionCreators(testAlert, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(Alerts);



// WEBPACK FOOTER //
// ./src/views/pages/bikes/alerts.js